module.exports = __webpack_public_path__ + "media/images/locations/basel-5e99fa646df49174f0ab1e80a3bdfd52.jpg";